/**
 * DocViewSchema for Item Group DocType
 *
 * Tab structure:
 * - Details: General settings, storefront config
 * - Defaults & Tax: Item group defaults table, item tax table
 * - More Info: Unmapped meta fields
 */

import type { DocViewSchema } from "./types";

export const itemGroupDocViewSchema: DocViewSchema = {
  doctype: "Item Group",
  views: {
    experience: {
      style: "shopify",

      sections: [
        {
          id: "general",
          label: "General Settings",
          description: "Item group identity, hierarchy, and image",
          layout: "two-column",
          fields: [
            "item_group_name",
            "parent_item_group",
            "is_group",
            "image",
          ],
        },
        {
          id: "storefront",
          label: "Storefront",
          description: "Storefront visibility and URL slug",
          widgetId: "ItemGroupStorefrontWidget",
          fields: [
            "storefront_enabled",
            "storefront_slug",
          ],
        },
        {
          id: "defaults",
          label: "Item Group Defaults",
          description: "Default warehouse, cost center, and other defaults for items in this group",
          fields: [
            "item_group_defaults",
          ],
        },
        {
          id: "taxes",
          label: "Item Tax",
          description: "Tax templates applied to items in this group",
          fields: [
            "taxes",
          ],
        },
      ],

      tabs: [
        {
          id: "details",
          label: "Details",
          sectionIds: ["general", "storefront"],
        },
        {
          id: "defaults-tax",
          label: "Defaults & Tax",
          sectionIds: ["defaults", "taxes"],
        },
      ],

      quickActions: [],
      connectionGroups: [],
    },

    system: {
      sections: [
        {
          id: "general",
          label: "General Settings",
          layout: "two-column",
          fields: [
            "item_group_name",
            "parent_item_group",
            "is_group",
            "image",
          ],
        },
        {
          id: "storefront",
          label: "Storefront",
          widgetId: "ItemGroupStorefrontWidget",
          fields: [
            "storefront_enabled",
            "storefront_slug",
          ],
        },
        {
          id: "defaults",
          label: "Item Group Defaults",
          fields: ["item_group_defaults"],
        },
        {
          id: "taxes",
          label: "Item Tax",
          fields: ["taxes"],
        },
      ],
      tabs: [
        {
          id: "details",
          label: "Details",
          sectionIds: ["general", "storefront"],
        },
        {
          id: "defaults-tax",
          label: "Defaults & Tax",
          sectionIds: ["defaults", "taxes"],
        },
      ],
    },
  },
};
